import React, { Component } from 'react'
import { connect } from 'react-redux'
import VerificarPatenteDialogView from './VerificarPatenteDialogView'

class VerificarPatenteDialog extends Component {
  render () {
    const { cpe } = this.props
    return (
      <VerificarPatenteDialogView className='dialog-foto-patente' cpe={cpe} />
    )
  }
}

const mapStateToProps = state => {
  return {
    cpe: state.calado.cpe
  }
}
export default connect(mapStateToProps)(VerificarPatenteDialog)
